(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collections-tabs"] && !Shopify.designMode) return;
  try {
    
  class CollectionsTabs extends HTMLElement {
    constructor() {
      super();
      this._onClick = this._onClick.bind(this);
      this._onKeydown = this._onKeydown.bind(this);
      this._onBlockSelect = this._onBlockSelect.bind(this);
    }

    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-collection-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-collection-panel]'));
      this.nav = this.querySelector('[data-collection-tablist]');
      if (!this.nav || !this.tabs.length) return;
      this._select(this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0], false);
      this.addEventListener('click', this._onClick);
      this.nav.addEventListener('keydown', this._onKeydown);
      this.addEventListener('shopify:block:select', this._onBlockSelect);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      if (this.nav) this.nav.removeEventListener('keydown', this._onKeydown);
      this.removeEventListener('shopify:block:select', this._onBlockSelect);
    }

    _select(button, focus) {
      this.tabs.forEach((tab) => {
        const active = tab === button;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== button.getAttribute('aria-controls');
      });
      if (focus) button.focus();
    }

    _onClick(event) {
      const button = event.target.closest('[data-collection-tab]');
      if (this.tabs.includes(button)) this._select(button, false);
    }

    _onKeydown(event) {
      const current = this.tabs.indexOf(document.activeElement);
      if (current === -1) return;
      let next = null;
      if (event.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
      else if (event.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = this.tabs.length - 1;
      if (next === null) return;
      event.preventDefault();
      this._select(this.tabs[next], true);
    }

    _onBlockSelect(event) {
      const button = event.target.closest('[data-collection-tab]');
      if (this.tabs.includes(button)) this._select(button, false);
    }
  }

  if (!customElements.get('collections-tabs')) customElements.define('collections-tabs', CollectionsTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-hotspots"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('image-hotspots')) {
  customElements.define('image-hotspots', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.points = [...this.querySelectorAll('[data-hotspot]')];
      this.panels = [...this.querySelectorAll('[data-hotspot-panel]')];
      this.points.forEach(point => { point.hidden = false; });
      this.select(null);
      this.addEventListener('click', event => {
        const point = event.target.closest('[data-hotspot]');
        if (point) this.select(point.getAttribute('aria-expanded') === 'true' ? null : point.dataset.hotspot);
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || event.defaultPrevented || event.target.closest('quick-buy')) return;
        const open = this.points.find(point => point.getAttribute('aria-expanded') === 'true');
        if (open) { this.select(null); open.focus(); event.preventDefault(); }
      }, options);
      this.addEventListener('shopify:block:select', event => { this.select(event.detail.blockId); }, options);
    }
    select(id) {
      this.points.forEach(point => point.setAttribute('aria-expanded', String(point.dataset.hotspot === id)));
      this.panels.forEach(panel => { panel.hidden = panel.dataset.hotspotPanel !== id; });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  class ArticleShare extends HTMLElement {
    constructor() {
      super();
      this._onClick = this._onClick.bind(this);
    }
    connectedCallback() {
      if (!this.querySelector('[data-share-url]')) {
        this._initFrame = requestAnimationFrame(() => this._initialize());
        return;
      }
      this._initialize();
    }
    _initialize() {
      if (!this.isConnected) return;
      this.input = this.querySelector('[data-share-url]');
      this.status = this.querySelector('[data-share-status]');
      if (!this.input || !this.status) return;
      this.querySelector('[data-share-copy]').hidden = false;
      this.querySelector('[data-share-native]').hidden = typeof navigator.share !== 'function';
      this.addEventListener('click', this._onClick);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this._initFrame);
      this.removeEventListener('click', this._onClick);
    }
    async _copy() {
      try {
        if (!navigator.clipboard || !navigator.clipboard.writeText) throw new Error('clipboard unavailable');
        await navigator.clipboard.writeText(this.input.value);
        this.status.textContent = this.dataset.copied;
      } catch (_) {
        this.input.focus();
        this.input.select();
        this.status.textContent = this.dataset.manual;
      }
    }
    async _onClick(event) {
      const button = event.target.closest('[data-share-copy], [data-share-native]');
      if (!button || !this.contains(button) || this.busy) return;
      this.busy = true;
      this.status.textContent = '';
      try {
        if (button.hasAttribute('data-share-native') && typeof navigator.share === 'function') {
          try { await navigator.share({ title: this.dataset.title, url: this.input.value }); }
          catch (error) { if (error.name !== 'AbortError') await this._copy(); }
        } else { await this._copy(); }
      } finally { this.busy = false; }
    }
  }
  if (!customElements.get('article-share')) customElements.define('article-share', ArticleShare);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"] && !Shopify.designMode) return;
  try {
    
const scopeRedirect = document.querySelector('[data-search-scope-redirect]');
if (scopeRedirect && !window.Shopify?.designMode) {
  const url = new URL(window.location.href);
  if (url.searchParams.get('type') !== scopeRedirect.dataset.searchTypes) {
    url.searchParams.set('type', scopeRedirect.dataset.searchTypes);
    url.searchParams.delete('page');
    window.location.replace(url.href);
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('recently-viewed')) return;
    class RecentlyViewed extends HTMLElement {
      connectedCallback() {
        if (this.loaded && !this.abort?.signal.aborted) return;
        this.loaded = false;
        // F04 : l'historique ne se charge qu'à l'approche de la section
        this.start = () => {
          if (!this.isConnected) return;
          if (!('IntersectionObserver' in window) || window.Shopify?.designMode) {
            this.load();
            return;
          }
          this.observer = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.observer.disconnect();
            this.load();
          }, { rootMargin: '300px 0px' });
          this.observer.observe(this);
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.start, { once: true });
        else this.start();
      }
      async load() {
        if (this.loaded) return;
        this.loaded = true;
        this.abort?.abort();
        const abort = new AbortController();
        this.abort = abort;
        const section = this.querySelector('[data-rv-section]'), grid = this.querySelector('[data-rv-grid]');
        if (!section || !grid) return;
        let handles;
        try { handles = JSON.parse(localStorage.getItem('converto-recently-viewed') || '[]'); } catch (e) { handles = []; }
        if (!Array.isArray(handles)) handles = [];
        handles = [...new Set(handles.filter((h) => typeof h === 'string' && h && h !== this.dataset.currentHandle))].slice(0, Math.min(10, Number(this.dataset.max) || 4));
        const root = (this.dataset.rootUrl || '/').replace(/\/$/, '');
        const cards = await Promise.all(handles.map(async (handle) => {
          try {
            const response = await fetch(`${root}/products/${encodeURIComponent(handle)}?section_id=product-cards`, { signal: abort.signal });
            if (!response.ok) return null;
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            return doc.querySelector('[data-product-cards] > .product-card');
          } catch (e) { return null; }
        }));
        if (abort.signal.aborted || !this.isConnected) return;
        const valid = cards.filter(Boolean);
        grid.replaceChildren(...valid);
        section.hidden = !valid.length;
        const note = this.querySelector('[data-rv-editor-note]');
        if (note) note.hidden = !!valid.length;
        Converto.ensureQuickBuy?.(grid);
      }
      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.start);
        this.observer?.disconnect();
        this.abort?.abort();
      }
    }
    customElements.define('recently-viewed', RecentlyViewed);
  })();

  } catch(e) { console.error(e); }
})();
})();
